function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.833 11.491s8.885-1.11 12.217 0c7.068 2.356 6.664 13.328 3.554 19.992-1.693 3.629-6.33 10.885-6.33 10.885l-1.111-7.997s1.781-1.045 2.776-2.888c3-5.553 3.332-14.438-.444-15.993-3.776-1.555-6.886 3.11-6.886 3.11M12.954 11.491H2.958c4.736 5.256 4.522 7.846 5.553 11.107"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.514 54.836c0-28.539 9.696-51.675 21.658-51.675 11.96 0 21.658 23.136 21.658 51.675l-.001.526H3.516l-.002-.526M13.509 11.491h23.324M3.514 51.475H46.83"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.171 14.268a3.325 3.325 0 013.332 3.332v26.656a3.325 3.325 0 01-3.332 3.332 3.325 3.325 0 01-3.332-3.332V17.6a3.325 3.325 0 013.332-3.332zM22.395 42.59h2.221M22.395 38.147h2.221M22.395 33.704h2.221M22.395 29.262h2.221M22.395 24.819h2.221M22.395 20.376h2.221"
}));

var SvgTeapot = function SvgTeapot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeapot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Teapot.cfb028e1.svg";
export { ForwardRef as ReactComponent };